export default require('./ShowTitle').default
